module.exports = __webpack_public_path__ + "media/applicants/techcrunch-b06939c4.jpg";